{
	"groupName": "Mask {{index}}",
	"partBodySkin": "Body Skin",
	"partClothing": "Clothing",
	"partEyebrows": "Eyebrows",
	"partEyes": "Eyes",
	"partFacialSkin": "Facial Skin",
	"partHair": "Hair",
	"partLips": "Lips",
	"partPerson": "Person",
	"personNumbered": "Person {{index}}",
	"personPartNumbered": "Person {{index}} {{part}}",
	"typeBackground": "Background",
	"typeBrush": "Brush",
	"typeGradient": "Linear Gradient",
	"typeNumbered": "{{type}} {{index}}",
	"typePeople": "People",
	"typeRadial": "Radial Gradient",
	"typeSky": "Sky",
	"typeSubject": "Subject"
}
